/* eslint-disable no-undef */
import { erase, token } from '../../reducers/currentUser/currentUser.reducer';
import knownError from './knownError';

export const remove = url => new Promise((resolve, reject) =>
  fetch(url, {
    method: 'delete',
    headers: {
      Accept: 'application/json',
      Authorization: token(),
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.ok) return resolve();
      if (response.status === 400) return knownError(response, reject);
      if (response.status === 401) { document.location = '/login'; return erase(); }
      return reject();
    }));



// WEBPACK FOOTER //
// ./src/helpers/api/remove.js